import React from 'react'
import { formTypeList } from '../../constants/form'
import Form from './Form'

const AddNew = ({ setOpen, doorStyleId }) => {
    return (
        <Form
            formType={formTypeList.NEW}
            doorStyleId={doorStyleId}
            setOpen={setOpen}
        />
    )
}

export default AddNew
